import { useTheme } from '../../theme-provider';
export const LENTILS_MAX_LENGHT = 7;
export const LENTILS_MIDDLE_INDEX = Math.floor(LENTILS_MAX_LENGHT / 2);
export const useLentilWidth = () => {
    const theme = useTheme();
    return parseInt(theme.size.static350, 10);
};
export const useLentilsTransform = () => {
    const lentilWidth = useLentilWidth();
    const { direction } = useTheme();
    return (activeIndex, length) => {
        if (length <= LENTILS_MAX_LENGHT) {
            return `0`;
        }
        if (activeIndex >= length - (LENTILS_MIDDLE_INDEX + 1)) {
            return `${(direction === 'rtl' ? 1 : -1) *
                lentilWidth *
                (length - LENTILS_MAX_LENGHT)}px`;
        }
        if (activeIndex > LENTILS_MIDDLE_INDEX) {
            return `${(direction === 'rtl' ? 1 : -1) *
                lentilWidth *
                (activeIndex - LENTILS_MIDDLE_INDEX)}px`;
        }
        return `0`;
    };
};
export const useLentilsWidth = () => {
    const lentilWidth = useLentilWidth();
    return (length) => `${length * lentilWidth}px`;
};
export const useLentilsMaxWidth = () => {
    const lentilWidth = useLentilWidth();
    return `${LENTILS_MAX_LENGHT * lentilWidth}px`;
};
export function getRef(index, activeIndex, length, prevRef, nextRef) {
    if (activeIndex === 0 && index === length - 1) {
        return prevRef;
    }
    if (activeIndex === length - 1 && index === 0) {
        return nextRef;
    }
    if (index === activeIndex - 1) {
        return prevRef;
    }
    if (index === activeIndex + 1) {
        return nextRef;
    }
    return undefined;
}
export function isSmall(currentIndex, activeIndex, slideLength) {
    const isCorrected = slideLength > LENTILS_MAX_LENGHT;
    return isCorrected
        ? (activeIndex > LENTILS_MIDDLE_INDEX &&
            currentIndex < activeIndex - (LENTILS_MIDDLE_INDEX - 1) &&
            currentIndex < slideLength - (LENTILS_MAX_LENGHT - 1)) ||
            (currentIndex >= LENTILS_MAX_LENGHT - 1 &&
                currentIndex < slideLength - 1 &&
                currentIndex > activeIndex + (LENTILS_MIDDLE_INDEX - 1))
        : false;
}
